// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2q803","header2":"Header_header2__2ffBc","logo":"Header_logo__eBSI4","login":"Header_login__o7zPw"};